import { useState, useEffect } from 'react';
import { Facebook, Instagram, Youtube } from 'lucide-react';

const API_URL = window.location.hostname === 'localhost'
  ? 'http://localhost:5000'
  : 'https://kiyafet-magazasi-backend.vercel.app';

export function Footer() {
  const [footerData, setFooterData] = useState<any>(null);

  useEffect(() => {
    fetch(`${API_URL}/api/footer`)
      .then(r => r.json())
      .then(d => setFooterData(d))
      .catch(() => {});
  }, []);

  const iletisim = footerData?.iletisim || { telefon: '', email: '', whatsapp: '', calismaSaatleri: '' };
  const sosyal = footerData?.sosyalMedya || { instagram: 'https://www.instagram.com/ladioraboutique', facebook: 'https://www.facebook.com/ladioraladiora', twitter: '', youtube: 'https://www.youtube.com/@LadioraBoutique' };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div>
            <h4 className="text-white font-semibold mb-4">Kurumsal</h4>
            <ul className="space-y-2">
              <li><a href="/hakkimizda" className="hover:text-pink-400 transition-colors">Hakkımızda</a></li>
              <li><a href="/iletisim" className="hover:text-pink-400 transition-colors">İletişim</a></li>
              <li><a href="/kesfet" className="hover:text-pink-400 transition-colors">Blog</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Müşteri Hizmetleri</h4>
            <ul className="space-y-2">
              <li><a href="/siparis-takip" className="hover:text-pink-400 transition-colors">Sipariş Takibi</a></li>
              <li><a href="/yasal/mesafeli-satis-sozlesmesi" className="hover:text-pink-400 transition-colors">İade & Değişim</a></li>
              <li><a href="/sss" className="hover:text-pink-400 transition-colors">SSS</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Yasal</h4>
            <ul className="space-y-2">
              <li><a href="/yasal/kullanim-kosullari" className="hover:text-pink-400 transition-colors">Kullanım Koşulları</a></li>
              <li><a href="/yasal/gizlilik-politikasi" className="hover:text-pink-400 transition-colors">Gizlilik Politikası</a></li>
              <li><a href="/yasal/kvkk" className="hover:text-pink-400 transition-colors">KVKK Aydınlatma Metni</a></li>
              <li><a href="/yasal/cerez-politikasi" className="hover:text-pink-400 transition-colors">Çerez Politikası</a></li>
              <li><a href="/yasal/mesafeli-satis-sozlesmesi" className="hover:text-pink-400 transition-colors">Mesafeli Satış Sözleşmesi</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Bizi Takip Edin</h4>
            <div className="flex gap-3 mb-4">
              <a href={sosyal.instagram || 'https://www.instagram.com/ladioraboutique'} target="_blank" rel="noopener noreferrer" className="size-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-600 transition-colors"><Instagram className="size-5" /></a>
              <a href={sosyal.facebook || 'https://www.facebook.com/ladioraladiora'} target="_blank" rel="noopener noreferrer" className="size-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-600 transition-colors"><Facebook className="size-5" /></a>
              <a href={sosyal.youtube || 'https://www.youtube.com/@LadioraBoutique'} target="_blank" rel="noopener noreferrer" className="size-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-600 transition-colors"><Youtube className="size-5" /></a>
            </div>
            <p className="text-sm">
              <span className="text-white font-medium">Ladiora Boutique</span><br />
              {iletisim.telefon && <>📞 {iletisim.telefon}</>}
            </p>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-500">© 2026 Ladiora Boutique. Tüm hakları saklıdır.</p>
          <div className="flex items-center gap-2">
            <img src="https://cdn.jsdelivr.net/gh/nicehash/payment-icons@master/SVG/visa.svg" alt="Visa" className="h-8" />
            <img src="https://cdn.jsdelivr.net/gh/nicehash/payment-icons@master/SVG/mastercard.svg" alt="Mastercard" className="h-8" />
            <img src="https://cdn.shopier.com/assets/img/shopier-logo-white.png" alt="Shopier" className="h-6" onError={(e) => { (e.target as HTMLImageElement).style.display = 'none' }} />
          </div>
        </div>
      </div>
    </footer>
  );
}
